export type ModelVisibility = "show" | "hide"

export type ModelVisibilityKey = {
  providerID: string
  modelID: string
  defaultVisible?: boolean
}

export type ModelVisibilitySetting = {
  visibility: ModelVisibility
  updatedAt?: number
}

export function modelVisibilityKey(model: ModelVisibilityKey) {
  return `${model.providerID}:${model.modelID}`
}

export function resolveModelVisibility(model: ModelVisibilityKey, setting?: ModelVisibilitySetting) {
  if (setting?.visibility === "hide") return false
  if (setting?.visibility === "show" && setting.updatedAt) return true
  return model.defaultVisible ?? true
}

export function selectVisibleModels<T extends { id: string; provider: { id: string } }>(
  models: readonly T[],
  visible: (model: ModelVisibilityKey) => boolean,
) {
  return models.filter((model) => visible({ providerID: model.provider.id, modelID: model.id }))
}

export function partitionModelsByVisibility<T>(models: readonly T[], visible: (model: T) => boolean) {
  const enabled: T[] = []
  const hidden: T[] = []

  for (const model of models) {
    if (visible(model)) enabled.push(model)
    else hidden.push(model)
  }

  return { enabled, hidden }
}
